import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    displayNextClickSpinner = false;
    displayLoaderAt = [];

    constructor() { }

    isLoaderDisplay(position) {
        return this.displayLoaderAt.indexOf(position) !== -1;
    }

    // loader handling
    showLoader(position: any) {
        if (this.displayLoaderAt.indexOf(position) === -1) {
            this.displayLoaderAt.push(position);
        }
    }

    hideLoader(position: any) {
        setTimeout(() => {
            this.displayLoaderAt = this.displayLoaderAt.filter(x => x !== position);
        }, 1000);
    }

    resetLoader() {
        setTimeout(() => {
            this.displayLoaderAt = [];
        }, 1000);
    }
}
